<div class="type-ahead input-group">
  <div *ngIf="labelForSearchType.isLabelRequired" class="input-group-prepend search-type global-style">
    <span>{{labelForSearchType.labelValue | translate}}</span>
  </div>
  <!--<input id="typeahead-focus" type="text" class="form-control" [ngClass]="labelForSearchType ? 'group' : ''" [(ngModel)]="typeaheadModel.value.territoryId" [ngbTypeahead]="search"
         [resultFormatter]="formatter" (focus)="focus$.next($event.target.value)" (click)="click$.next($event.target.value)" (selectItem)="onSelectionChange($event)"
         #instance="ngbTypeahead" />-->
  <select id="typeahead-focus" class="form-control global-style" (change)="onSelectionChange()" [ngClass]="labelForSearchType ? 'group' : ''"
          [(ngModel)]="typeaheadModel.value.territoryId">
    <option *ngFor="let item of listOfSearchItems" [ngValue]="item.value.territoryId">{{item.name}}</option>
  </select>
  <span class="arrow-down"></span>
</div>
